import React from 'react';
import PropTypes from 'prop-types';

// Import Icon
import searchIcon from '~/common/images/search-icon-black.svg';

// Import Local Styles
import styles from './search-icon.css';

const SearchIconButton = (props) => {
    const { onClick } = props;
    return (
        <button
            className={styles.button}
            id="number-search__button"
            onClick={onClick}
            type="button"
        >
            <img className={styles.image} src={searchIcon}></img>
        </button>
    );
};

SearchIconButton.propTypes = {
    id: PropTypes.string,
    onClick: PropTypes.func
};

export default SearchIconButton;
